import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export function ImpressumPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-[#59d0d4]/30 selection:text-[#3b7780] flex flex-col" data-id="element-543">
      <Navbar data-id="element-544" />
      <main className="flex-grow pt-32 pb-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto w-full" data-id="element-545">
        <h1 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-10 tracking-tight" data-id="element-546">
          Impressum
        </h1>

        <div className="prose prose-slate max-w-none space-y-8" data-id="element-547">
          <section data-id="element-548">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-549">
              Angaben gemäß § 5 TMG
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-550">
              <strong data-id="element-551">2N Kurse GbR Dres. Schwenk, Striegel, Herzog</strong>
              <br data-id="element-552" />
              Ludwigsplatz 1a
              <br data-id="element-553" />
              90403 Nürnberg
            </p>
          </section>

          <section data-id="element-554">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-555">Kontakt</h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-556">
              Telefon: 0911 – 56836360
              <br data-id="element-557" />
              E-Mail: info@2n-fortbildung.de
            </p>
          </section>

          <section data-id="element-558">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-559">
              Vertreten durch
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-560">
              Dr. Thomas Schwenk
              <br data-id="element-561" />
              Dr. Markus Striegel
              <br data-id="element-562" />
              Dr. Johanna Herzog
            </p>
          </section>
        </div>
      </main>
      <Footer data-id="element-563" />
    </div>;
}